<template>
	<div class="competition">
		<div class="competition-div" v-for="(item,index) in list" :key="index">
			<div class="left">
				<div class="competition-div-div">
					<div class="red">{{item.type}}</div>
					<div class="title">{{item.name}}</div>
				</div>
				<div class="competition-div-div">
					<div>主办方&nbsp;&nbsp;&nbsp;&nbsp;</div>
					<div>{{item.merchant}}</div>
				</div>
				<div class="competition-div-div">
					<div>参赛范围</div>
					<div>{{item.scope}}</div>
				</div>
				<div class="competition-div-div">
					<div>报名时间</div>
					<div>{{item.apply_starttime|format_date}} ～{{item.apply_endtime|format_date}}</div>
				</div>
				<div class="competition-div-div">
					<div>比赛时间</div>
						<div>{{item.game_starttime|format_date}} ～{{item.game_endtime|format_date}}</div>
				</div>
			</div>
			<div class="right">
				<router-link :to="'/game/details?id='+item.id">
				
				竞赛详情 
				<img src="../../assets/shudo/images/u36.svg" />
				</router-link>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	  export default {
		 
		data() {
			return {
				merchanthot_id    :  '',
				list  :  []
			}	
		},
		created() {
			var  query = this.$route.query;
			if(query.merchanthot_id){
				this.merchanthot_id = query.merchanthot_id;
				this.getlist();
			}
		},
	    methods: {
			getlist(){
				let that = this;
				that.$http('get','/api/v1/merchant/merchantlist?merchant_id='+that.merchanthot_id,{}) .then(function (res) {
					that.list = res.data.list;
				});
			},
			
	    },
	}
</script>

<style lang="less">
	.competition {
		width: 90%;
		margin: auto;
		height: 30rem;
		.competition-div {
			width: 100%;
			margin-top: 0.6rem;
			margin-bottom: 0.6rem;
			height: 9rem;
			border-left: 0.6rem solid  rgba(217, 0, 27, 1);
			box-shadow: 2px 2px 1px rgb(127 127 127 / 35%);
			display: flex;
			.left {
				flex: 4;
				.competition-div-div {
					display: flex;
					padding-left: 1rem;
						font-size: 0.6rem;
					div{ margin-top: 0.4rem;}
					div:nth-last-child(1){
						padding-left: 1rem;
					}
					.title { 
						font-size: 0.9rem;
					}
					.red { color: rgba(217, 0, 27, 1); }
				}
			}
			.right {
				flex: 1;
				font-size: 1rem;
				line-height: 6rem;
				img {
					width: 0.6rem;
					position: relative;
					top: 0.1rem;
				}
			}
			
		}
		
	}
</style>
